// ENUMS #############################################################
export enum ErsLifecycleActionsEnum {
	ACTIVATE = 'activate',
	DISABLE = 'disable'
}

export enum ErsLifecycleModalActionsEnum {
	ABORT = 'abort',
	CONFIRM = 'confirm',
	WARNING_HIDE = 'warningHide',
	WARNING_SHOW = 'warningShow'
}

// INTERFACES ########################################################


// TYPES #############################################################


// ENTITIES ##########################################################

